import type Chat from "../components/chat/Chat";
import type Message from "../components/chat/Message";
import API, { responseOf } from "./base";

export const createChat = (organizationId: string): Promise<Chat> =>
  responseOf(
    API.post("/copilot-chats/", undefined, {
      params: {
        organizationId,
      },
    }),
  );

export const sendMessage = (
  organizationId: string,
  chatId: string,
  message: Message,
): Promise<Message> =>
  responseOf(
    API.post(`/copilot-chats/${chatId}/messages`, message, {
      params: {
        organizationId,
      },
    }),
  );

export const getChat = (chatId: string): Promise<Chat> =>
  responseOf(API.get(`/copilot-chats/${chatId}`));
